import { Anchor } from '@components/atoms/Anchor';
import Section from '@components/atoms/Section';
import { Heading1, Paragraph } from '@components/atoms/Typography';
import BreadCrumbs from '@components/molecules/BreadCrumbs';
import BasicHeader from '@components/molecules/headers/BasicHeader';
import PageContainer from '@components/molecules/PageContainer';
import BREAKPOINTS from '@lib/constants/breakpoints';
import env from '@lib/constants/env';
import ROUTES from '@lib/constants/routes';
import { STATES } from '@shared/constants';
import { GetStaticPaths, GetStaticProps } from 'next';
import { BreadcrumbJsonLd } from 'next-seo';
import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

const VehicleList = styled.ul`
  margin: 0 0;
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr 1fr 1fr;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    grid-template-columns: 1fr;
  }
`;
interface Props {
  year: string;
}

const Page = ({ year }: Props) => {
  if (!year) return <PageContainer loading />;

  const links = [
    {
      label: 'Luna',
      href: '/',
    },
    {
      label: 'IPVA',
      href: ROUTES.ipva,
    },
    {
      label: year,
      href: ROUTES.ipvaYear({ year }),
    },
  ];

  return (
    <PageContainer
      title={`Consulta IPVA ${year}`}
      metaDescription={`Veja preços IPVA ${year} para Automóveis, motos, carros, caminhões, ônibus e moto casa - Consultar valor venal e simular IPVA ${year} a pagar para o seu veículo por estado.`}
    >
      <BreadcrumbJsonLd
        itemListElements={links.map((item, index) => ({
          position: index + 1,
          item: `${env.baseUrl}${item.href}`,
          name: item.label,
        }))}
      />
      <BasicHeader>
        <Heading1 center>
          IPVA
          {` ${year}`}
        </Heading1>
        <Paragraph center>
          O IPVA é um imposto que difere de estado para estado e a sua
          arrecadação é responsabilidade da Secretaria de Estado da Fazenda,
          sendo metade do imposto recolhido é para o município do licenciamento
          do veículo enquanto o restante é para os cofres do estado.
        </Paragraph>
      </BasicHeader>
      <Section pastel>
        <VehicleList>
          {Object.entries(STATES).map(([uf, state]) => (
            <li key={state}>
              <Link
                href={ROUTES.ipvaState({
                  uf: uf as string,
                  year,
                })}
                passHref
              >
                <Anchor>
                  IPVA
                  {` ${year} ${state} `}
                </Anchor>
              </Link>
            </li>
          ))}
        </VehicleList>
      </Section>
      <Section>
        <BreadCrumbs links={links} />
      </Section>
    </PageContainer>
  );
};

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const { year } = params as Record<string, string>;

  return {
    props: {
      year,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => ({
  // eslint-disable-next-line no-underscore-dangle
  paths: ['/ipva/2021', '/ipva/2022', '/ipva/2023'],
  fallback: false,
});

export default Page;
